<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="search-field-provider-expand-modal"
      dialog-max-height="40rem"
    >
      <template #header>{{ ls(def.name) }}</template>
      <template #header-extra>
        <div class="jps-round-input-wrapper">
          <UiInputRound class="jps-round-input" v-model="filter"/>
        </div>
      </template>
      <div class="jps-modal-content layout-col search-field-provider-expand-modal-body">
        <UiOrgProviderSpan
          :class="{ 'is-selected': isSelected(value) }"
          class="org-row"
          v-for="(count, value) in sortedFacet"
          :key="value"
          tag="div"
          :id="value"
          @click="select(value)"
        >
          <template v-slot="{ org }">
            <div class="org-row-checkbox">
              <BaseCheckbox
                :model-value="isSelected(value)"
                @update:model-value="select(value)"
              />
            </div>
            <div class="image-selection">
              <UiImageSelection
                type="organization"
                :image="org.image"
                background="transparent"
                image-usage="thumbnail"
              />
            </div>
            <div>
              {{ ls(org.name) }}
            </div>
            <div class="count">{{ num(count) }}</div>
            <div class="description">{{ ls(org.description) }}</div>
          </template>
        </UiOrgProviderSpan>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
        <button @click="modal.resolve(selected)">
          {{ lss('絞り込み', 'Narrow down') }}
        </button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'
import { useSearchFieldExpand } from '~/components/search/search-field/useSearchFieldExpand'
import type { SearchFieldExpandProps } from '~/components/search/search-field/useSearchFieldExpand'

const { ls, lss, num } = useI18n()

interface Props extends SearchFieldExpandProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const { init, selected, select, isSelected, sortedFacet, filter } = useSearchFieldExpand(props)

const modal = ref<InstanceType<typeof BaseModal>>()
const openAwait = async () => {
  init()
  return await modal.value.openAwait<string[]>()
}
defineExpose({ openAwait })
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.search-field-provider-expand-modal {
}

.jps-round-input-wrapper {
  padding: 0.5rem 1.25rem;
  width: 100%;
}

.jps-round-input {
  background: $white !important;
  width: 100% !important;
}
.org-row {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid $border-grey;
  padding: 1rem 0.5rem;
  cursor: pointer;
  position: relative;
  gap: 0.5rem;

  @include is-tablet {
    display: grid;
    grid-template-columns: 2rem 6rem 8rem 4rem 1fr;
    gap: 1rem;
    padding: 1rem;
  }

  .org-row-checkbox {
    @include is-mobile {
      position: absolute;
      left: 0.5rem;
      top: 0.5rem;
    }
  }

  .image-selection {
    width: 6rem;
    height: 6rem;

    @include is-mobile {
      margin: 0 auto;
    }
  }

  &:first-child {
    border-top: 1px solid $border-grey;
  }

  .description {
    font-size: 0.75rem;
  }
  .count {
    font-size: 1rem;
    @include is-tablet {
      text-align: right;
    }
  }
}

.search-field-provider-expand-modal-body {
    gap: 1rem;
}
</style>
